var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0243 1.80103V0.169222C11.0243 0.0277846 10.8617 -0.0503227 10.7519 0.0362286L1.23551 7.46908C1.15466 7.53196 1.08923 7.61248 1.04423 7.70449C0.999225 7.7965 0.97583 7.89757 0.97583 8C0.97583 8.10243 0.999225 8.2035 1.04423 8.29551C1.08923 8.38752 1.15466 8.46804 1.23551 8.53092L10.7519 15.9638C10.8638 16.0503 11.0243 15.9722 11.0243 15.8308V14.199C11.0243 14.0955 10.9757 13.9963 10.8955 13.933L3.29586 8.00105L10.8955 2.06702C10.9757 2.00369 11.0243 1.90447 11.0243 1.80103Z",
    color: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.57b11cd9fbef560a98fa458205fb0f3b.svg";
export { ForwardRef as ReactComponent };